"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Tencent is pleased to support the open source community by making SPA UI available.
 * Copyright (C) 2019, a Tencent company. All rights reserved.
 */
var _default = function _default() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var onShow = typeof props.onShowChange !== 'undefined' ? props.onShowChange : props.onShow;
  var hideDelayTime = typeof props.delay !== 'undefined' ? props.delay : props.hideDelayTime;
  var showDelayTime = props.showDelayTime; // 如果为hover且没有指定展示延迟，就默认都用100ms的延迟时间，避免鼠标很快移动过去也展示了内容

  if (props.trigger === 'hover' && typeof showDelayTime === 'undefined') {
    showDelayTime = 100;
  }

  return _objectSpread({}, props, {
    onShow: onShow,
    hideDelayTime: hideDelayTime,
    showDelayTime: showDelayTime
  });
};

exports["default"] = _default;